import http from "../../http";

const login = {
    getDomainParaJson() {
        return  http.get("/gateway/api/auth/pc/permissions/getDomainParaJson", )
    },
}
export default login
